export const OFFICE_PLATFORMS = {
  PC: "PC",
  ONLINE: "Online",
  MAC: "Mac"
};
